import { cn } from "@/lib";
import { dropdownVariants } from "@/styles/variants";
import { ReactNode } from "react";
import { BdAltArrowDown } from "solar-icon-react/bd";
import { FlexBetween } from "..";

interface Props {
  label: string;
  isOpen: boolean;
  onClick: () => void;
  variant?: "default" | "primary" | "outline" | "shadow" | "flat" | null;
  startIcon: ReactNode;
}

const DropdownTrigger = ({
  label,
  isOpen,
  onClick,
  variant,
  startIcon,
}: Props) => {
  return (
    <FlexBetween
      onClick={onClick}
      className={cn(
        dropdownVariants({ variant }),
        "text-micro sm:gap-2 sm:text-sm",
      )}
    >
      {startIcon}
      <span className={cn("grow")}>{label}</span>
      <span className="h-3 w-3 sm:h-4 sm:w-4">
        <BdAltArrowDown
          className={cn(
            "text-primary-main! size-full! transition-transform",
            isOpen && "rotate-180",
          )}
        />
      </span>
    </FlexBetween>
  );
};

export default DropdownTrigger;
